module.exports = __webpack_public_path__ + "img/ca.b325e043.svg";